import React, { useCallback } from 'react';

import Button from 'components/form/Button.component';
import FlareConfetti from 'components/generic/flare/FlareConfetti.component';
import FlareStar from 'components/generic/flare/FlareStar.component';
import Tooltip from 'components/generic/Tooltip.component';
import DELAY from 'constants/delay.const';
import S from 'constants/string.const';
import useTip from 'hooks/useTip.hook';
import delayed from 'utils/functions/delayed.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import CN from './UiPage.module.scss';

const TOOLTIP_TEXT = ['This feature has been temporarily disabled for maintenance. ', 'It should be live again in 24-48 hours'].join(S.space);

const TooltipContent = () => (
  <div data-bem="TooltipPanel--TooltipContent">
    Long content
    <br />
    Choose which KPIs you want visible and which order they appear in. hit the edit KPIs button to see options for adding and removing KPIs and the ability to reorder KPIs with drag and drop Choose
    which KPIs you want visible and which order they appear in. hit the edit KPIs...
  </div>
);

const TooltipPanel = () => {
  const { val: isConfettiRendered, yay: drop, nay: clean } = useTip();
  const handleConfetti = useCallback(() => {
    drop();
    delayed(DELAY.autohide, clean);
  }, [clean, drop]);

  return (
    <div data-bem="TooltipPanel" className={CN.container}>
      <div className={CN.display}>
        <div className={CN.title}>WIDTH - default is lg</div>
        <div className={CN.horizontalFlex}>
          <Tooltip variant="top" width="auto" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              auto - px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="s2" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              s2 - 130px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="xs" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              xs - 160px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="sm" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              sm - 190px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="md" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              md - 204px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="lg" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              lg - 240px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="l2" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              l2 - 298px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="l3" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              l3 - 300px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="l3" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              l3 - 320px
            </Button>
          </Tooltip>
          <Tooltip variant="top" width="max" content="I am only text">
            <Button variant="outline" width="medium" onClick={alwaysNoop}>
              max - 400px
            </Button>
          </Tooltip>
        </div>
        <div className={CN.title}>
          Variant <strong> Default </strong>
        </div>
        <Tooltip variant="top" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            top
          </Button>
        </Tooltip>
        <Tooltip variant="topLeft" content="useful in mobile when the button is at the beginning">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            topLeft
          </Button>
        </Tooltip>
        <Tooltip variant="topRight" content="useful in mobile when the button is at the end">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            topRight
          </Button>
        </Tooltip>
        <Tooltip variant="left" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            left
          </Button>
        </Tooltip>
        <Tooltip variant="bottom" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            bottom
          </Button>
        </Tooltip>
        <Tooltip variant="right" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            right
          </Button>
        </Tooltip>
        <Tooltip variant="leftToBottom" width="md" content={<TooltipContent />}>
          <Button variant="outline">leftToBottom</Button>
        </Tooltip>
        <Tooltip variant="bottomBottom" width="md" content={<TooltipContent />}>
          <Button variant="outline">bottomBottom</Button>
        </Tooltip>

        <div className={CN.title}>
          Variant <strong> Slick </strong>
        </div>
        <Tooltip variant="slickTop" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            slickTop
          </Button>
        </Tooltip>

        <Tooltip variant="slickLeft" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            slickLeft
          </Button>
        </Tooltip>
        <Tooltip variant="slickBottom" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            slickBottom
          </Button>
        </Tooltip>
        <Tooltip variant="slickRight" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            slickRight
          </Button>
        </Tooltip>
        <Tooltip variant="slickRightToBottom" content={<TooltipContent />}>
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            slickRightToBottom
          </Button>
        </Tooltip>
        <Tooltip variant="slickBottomToLeft" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            slickBottomToLeft
          </Button>
        </Tooltip>
        <Tooltip variant="slickTopToLeft" content="I am only text slickTopToLeft">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            slickTopToLeft
          </Button>
        </Tooltip>

        <Tooltip variant="slickBottomToBottom" width="lg" content="I am only text slickBottomToBottom slickBottomToBottom slickBottomToBottom slickBottomToBottom">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            slickBottomToBottom
          </Button>
        </Tooltip>
        <div className={CN.title}>
          Variant <strong>quaternary - oldest design</strong>
        </div>

        <Tooltip variant="quaternaryTop" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            quaternaryTop
          </Button>
        </Tooltip>
        <Tooltip variant="quaternaryLeft" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            quaternaryLeft
          </Button>
        </Tooltip>
        <Tooltip variant="quaternaryBottom" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            quaternaryBottom
          </Button>
        </Tooltip>
        <Tooltip variant="quaternaryRight" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            quaternaryRight
          </Button>
        </Tooltip>
        <Tooltip variant="quaternaryLeftToBottom" width="md" content={<TooltipContent />}>
          <Button variant="outline">quaternaryLeftToBottom</Button>
        </Tooltip>
        <div className={CN.title}>
          Variant <strong>comingSoon</strong>
        </div>
        <Tooltip variant="comingSoon" position="bottom" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            comingSoon bottom
          </Button>
        </Tooltip>
        <div className={CN.title}>
          <strong>Variant custom</strong>
        </div>
        <Tooltip custom content={TOOLTIP_TEXT}>
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            custom
          </Button>
          <small>(tooltip has slight gradient) -- PermissionLevelTooltip in edit stylist</small>
        </Tooltip>
        <div className={CN.title}>
          <strong>
            Variant primaryBottom <small>(in HumanResourcesMenu only)</small>
          </strong>
        </div>
        <Tooltip variant="primaryBottom" content="I am only text">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            primaryBottom
          </Button>
        </Tooltip>
        <div className={CN.title}>
          <strong>
            Variant timeOffCategory <small>(in CategoryTimeOff only)</small>
          </strong>
        </div>
        <Tooltip variant="timeOffCategory" content="Upgrade plan to access">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            timeOffCategory
          </Button>
        </Tooltip>
        <div className={CN.title}>
          <strong>
            Variant tertiary <small>In stylist permissions only / left: 28%</small>
          </strong>
        </div>
        <Tooltip variant="tertiary" content="In stylist permissions">
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            tertiary
          </Button>
        </Tooltip>
      </div>

      <div className={CN.display}>
        <Button onClick={handleConfetti}>Drop Confetti</Button>
        {isConfettiRendered && <FlareConfetti />}
      </div>

      <div className={CN.display} data-bem="TooltipPanel__Star">
        <p>Star/Sparkle</p>
        <FlareStar size="18" top={910} right={50} variant="dark" />
        <FlareStar size="22" top={920} right={150} animation="pulse" variant="dark" />
        <FlareStar size="25" top={930} right={250} animation="pulse" />
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default TooltipPanel;
